var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPricePerUnit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "price_per_unit_svg__a",
  width: 36,
  height: 36,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#price_per_unit_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M3.598 21.184v-9.901a2.11 2.11 0 0 0 2.109-2.11h21.197a2.11 2.11 0 0 0 2.11 2.11v9.9a2.11 2.11 0 0 0-2.11 2.11H5.707a2.11 2.11 0 0 0-2.11-2.11"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M9.246 16.236a1.412 1.412 0 1 1-2.824 0 1.412 1.412 0 0 1 2.824 0M26.19 16.236a1.412 1.412 0 1 1-2.825 0 1.412 1.412 0 0 1 2.824 0M20.542 16.233a4.236 4.236 0 1 1-8.472 0 4.236 4.236 0 0 1 8.472 0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M2.89 26.119v3.53h32.476V8.468h-3.53"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M31.837 26.117H.773V6.35h31.064z"
}))));
export default SvgPricePerUnit;